import {
    rotated,
    set_inanim,
    inanim,
    in_free_spins,
    states,
    set_inwincount,
    he_scale,
    picture_convert,
    madnes_objects,
    inmoneyadd,
    inbigwin,
    server_result,
    set_in_free_spins, set_rotated, set_round_running, freespins, wi_scale, set_server_result
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_add_win,
    madnes_end_freespins,
    madnes_end_round,
    madnes_fill_range,
    madnes_set_hand_cursor,
    madnes_set_input_down, madnes_set_win,
    madnes_start_freespins,
    madnes_win_anim_reset,
    madnes_win_anim_skip
} from "../framework/src/engine/madnes/madnes";
import {STATES} from "../framework/src/states/states";
import {
    madnes_add_child,
    madnes_add_img,
    madnes_add_sprite, madnes_get_dimension, madnes_get_dimension_he, madnes_get_dimension_wi,
    madnes_get_pos_x,
    madnes_get_pos_y, madnes_get_texture, madnes_key_exist, madnes_remove_sprite, madnes_set_alpha,
    madnes_set_cstm_val, madnes_set_img_center, madnes_set_pos_x,
    madnes_set_pos_y,
    madnes_set_texture,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {icons, win_lines} from "./rof_config";
import {
    madnes_audio_loop,
    madnes_audio_pause,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_anim_add,
    madnes_anim_add_oncomplete,
    madnes_anim_loop,
    madnes_anim_play, madnes_anim_stop
} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_add_bitmap_text, madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {madnes_anim_pulse, madnes_fade_in, madnes_fade_out} from "./rof_anims";
import {devil_wink_eye_animation} from "./rof_core";
import {AnimPulse} from "./rof_extanims";
import {ctrl_end_round_freespins, money_add_control} from "./rof_end_ctrl";
import {set_result_lock} from "./rof_core_printer";
import AddResult from "../framework/src/connect/result/AddResult";


function getArrayRandValue(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

// Zacatek kontroly vyher
var result_control_pos = 0;
var spin_win = 0;

export function result_control()
{
    spin_win = 0;

    if(inmoneyadd || inbigwin)
    {
        setTimeout(result_control, 100);
        return;
    }

    set_inanim(1);
    result_control_pos = 0;

    result_control_part();
}


async function add_line_win(lineWin)
{
    if(typeof lineWin['win'] !== 'undefined') {
        await madnes_add_win(lineWin['win'] * 1);
        // win += lineWin['win'] * 1;
        spin_win += lineWin['win'] * 1;
    }
}

// kontrola vyhry na aktualni pozici
async function result_control_part()
{
    var lw = server_result.result.lineWins;

    if(lw == null || server_result.result.lineWins[result_control_pos] == null)
    {
        madnes_win_anim_reset();

        if(in_free_spins)
        {
            control_freespins(false);
        }
        else
        {
            money_add_control();
        }

        if(lw != null)
        {
            set_inwincount(false); // inwincount = false;
        }
    }
    else
    {

        var lineWin = server_result.result.lineWins[result_control_pos];
        var scatterCount = 0;

        try {
            scatterCount = server_result['result']['gameSpecifics']['scatterPositions'].length;
        } catch (e) {}

        if(lineWin.type == "scatter" && scatterCount > 2) {
            states.setState(STATES.BONUS);
        } else {
            states.setState(STATES.SKIP);
        }

        // autospin_force_enabled = false;

        // madnes_hide_stop();

        if(madnes_win_anim_skip()) {
            //if(
            //	server_result.result.lineWins[result_control_pos].type == "wild" ||
            //	server_result.result.lineWins[result_control_pos].type == "normal"
            //) {

            await add_line_win(lineWin);

            result_control_pos++;
            result_control_part();
            //} else {
            //	result_control_part_proc(server_result.result.lineWins[result_control_pos]);
            //}
        } else {
            result_control_part_proc(lineWin);
        }
    }
}

// kontrola aktualni vyhry
var fireQLocked = false;
var fireQs = [];
var hidedSprites = [];

var fsCurrent;
var fsTotal;

async function result_control_part_proc(win_set)
{
    set_inwincount(true);
    var linenum = 0;
    if(typeof win_set['line'] != "undefined" && win_set['line'] != null && win_set['line'] >= 0)
    {
        linenum = 1;
    }

    if(linenum != 0)
    {
        // madnes_win_anim_add();

        madnes_set_visible(win_lines[win_set['line']]['line'], true);

        //madnes_audio_pause('background');
        result_control_part_proc_rem_color(win_set);
    }
    else if(win_set['type'] == "scatter")
    {
        if (win_set['position'].length > 2)
            madnes_start_freespins();

        set_inwincount(false);

        await add_line_win(win_set);

        if(!in_free_spins)
        {
            madnes_audio_pause('background');
            //madnes_audio_play('FS_START');
            //setTimeout("madnes_audio_loop('FS_BG');", 1000);
        }

        var scatterCount = server_result['result']['gameSpecifics']['scatterPositions'].length;

        madnes_audio_play('snd_win_bonus' + get_yes(win_set));

        /*		var cname = "lfspos_" + server_config.session_id;
                var cookieFsIdx = madnes_get_cookie(cname);
                if(cookieFsIdx > -1 && !in_free_spins) {

                    continueScatter();

                } else */

        if(scatterCount < 3) {

            // madnes_win_anim_add();

            var drawFrames = new FrameDrawer(win_set);
            drawFrames.moveFrameY = 7 * wi_scale;
            drawFrames.draw('yellow');
            drawFrames.animSymbols();

            //drawFrames.scaleSymbols(drawFrames.animSymbols.bind(drawFrames));

            setTimeout(function() {
                drawFrames.endDraw();

                result_control_pos++;
                result_control_part();
            }, 3000);

        } else {

            fsCurrent = freespins.getFreeSpinNumber();
            freespins.run(new AddResult(server_result));
            fsTotal = freespins.getFreeSpinNumber();

            if(freespins.isSkipping()) {
                continueScatter();
                return;
            }

            // var fsResults = server_result.result.freeSpinResults;

            actual_freespins_count = fsTotal - fsCurrent;

            // if(in_free_spins_pos === 0) {
            // 	actual_freespins_count = server_result['result']['freeSpinNumber'];
            // } else if(in_free_spins_pos === 1) {
            // 	actual_freespins_count = fsResults[in_free_spins_pos - 1]['result']['freeSpinNumber'] - server_result['result']['freeSpinNumber'];
            // } else {
            // 	actual_freespins_count = fsResults[in_free_spins_pos - 1]['result']['freeSpinNumber'] - fsResults[in_free_spins_pos - 2]['result']['freeSpinNumber'];
            // }

            for(var pos in win_set['position']) {
                var itemX = win_set['position'][pos][0];
                var itemY = win_set['position'][pos][1];
                var itemSY = 2 - itemY;
                var spriteName = 'reels_bufer_' + itemX + '_S' + itemSY;
                var symbolTextureName = "symbol_Fire_burn";


                madnes_set_texture(spriteName, symbolTextureName);
                //madnes_set_texture(spriteName, picture_convert[ico]);

                if(typeof icons[symbolTextureName] != 'undefined' && icons[symbolTextureName].anim != 'undefined') {
                    madnes_anim_add(spriteName, "anim", icons[symbolTextureName]['anim']);
                    madnes_set_cstm_val(spriteName, spriteName);

                    madnes_anim_add_oncomplete(spriteName, function (sprite) {
                        madnes_set_texture(sprite['cstmVal'], "symbol_Fire");
                        //madnes_sprite_set_frame(sprite['cstmVal'], 0);

                        madnes_set_pos_y(sprite['cstmVal'], madnes_get_pos_y(sprite['cstmVal']) + 5);
                    });

                    madnes_set_pos_y(spriteName, madnes_get_pos_y(spriteName) - 5);

                    madnes_anim_play(spriteName, 'anim');
                }
            }

            setTimeout(function() {

                fireQs = [];
                hidedSprites = [];

                madnes_audio_loop('fire2');

                var autoSelectTimeout = setTimeout(function() {
                    var randVal = getArrayRandValue(fireQs);
                    selectFireQ(randVal['name']);
                }, 15000);


                for(var pos in win_set['position']) {
                    var itemX = win_set['position'][pos][0];
                    var itemY = 2 - win_set['position'][pos][1];
                    var spriteName = 'reels_bufer_' + itemX + '_S' + itemY;
                    madnes_set_visible(spriteName, false);
                    hidedSprites.push(spriteName);

                    var xPos = madnes_get_pos_x(spriteName) + 6 * he_scale;
                    var yPos = madnes_get_pos_y(spriteName);

                    var fireQName = 'fireQ_' + xPos + '_' + yPos;
                    var qMarkName = 'qMark_' + xPos + '_' + yPos;

                    madnes_add_sprite(fireQName, 'icon_Fire_Q', xPos, yPos);
                    madnes_anim_add(fireQName, 'anim', madnes_fill_range(0, 59));
                    madnes_anim_loop(fireQName, 'anim');

                    var fireQDim = madnes_get_dimension(fireQName);
                    var qMarkXPos = xPos + fireQDim['width'] / 2;
                    var qMarkYPos = yPos + fireQDim['height'] / 2 + 20;

                    madnes_add_img(qMarkName, 'fire_question', qMarkXPos, qMarkYPos);
                    madnes_set_img_center(qMarkName, 0.5, 0.5);

                    madnes_set_cstm_val(fireQName, xPos);
                    fireQs.push({ 'name': fireQName, 'qName': qMarkName });

                    var fireQClick = function(name) {
                        clearTimeout(autoSelectTimeout);

                        if(fireQLocked) {
                            return false;
                        }

                        fireQLocked = true;
                        selectFireQ(name);
                    };

                    madnes_set_input_down(fireQName, fireQClick.bind(this, fireQName));
                    madnes_set_hand_cursor(fireQName, true);

                }
            }, 2800);
        }

    } else {
        result_control_pos++;
        result_control_part();
        if(in_free_spins)
        {
            control_freespins(false);
        }
    }
}

function selectFireQ(name) {
    fireQLocked = true;

    var exceptNums = [];
    exceptNums.push(actual_freespins_count * 1);

    for(var f = 0; f < fireQs.length; f++) {
        madnes_remove_sprite(fireQs[f]['qName']);

        var freeSpinNum = getRandomFreeSpinNumberExcept(exceptNums);

        if(fireQs[f]['name'] !== name) {
            add_text_to_symbol(fireQs[f]['name'], freeSpinNum, false);
        }

        exceptNums.push(freeSpinNum);
    }

    add_text_to_symbol(name, actual_freespins_count, true);
    continueScatter();
}
function continueScatter()
{
    var timeout = 1000;
    var fsResult = server_result;
    var fsSkipping = false;

    if(!in_free_spins) {

        timeout = 2000;

        set_in_free_spins(true);
        // in_free_spins_pos = 0;

        if(freespins.isSkipping()) {
            fsSkipping = true;

            madnes_set_win(freespins.getResultWin());
        }

        // var cname = "lfspos_" + server_config.session_id;
        // var cookieFsIdx = madnes_get_cookie(cname);
        // if(cookieFsIdx > -1) {
        // 	fsSkipping = true;
        // 	in_free_spins_pos = cookieFsIdx * 1 + 1;
        //
        // 	fsResult = server_result['result']['freeSpinResults'][cookieFsIdx];
        // 	in_free_spins_total = fsResult['result']['freeSpinNumber'];
        //
        // 	if(typeof fsResult['result']['win'] !== 'undefined') {
        // 		win = fsResult['result']['win'];
        // 	}
        //
        // 	spin_win = 0;
        // 	if(typeof fsResult['result']['lineWins'] !== 'undefined') {
        // 		for(var i = 0; i < fsResult['result']['lineWins'].length; i++) {
        // 			if(typeof fsResult['result']['lineWins'][i]['win'] !== 'undefined') {
        // 				spin_win += fsResult['result']['lineWins'][i]['win'];
        // 			}
        // 		}
        // 	}
        // }
    }

    // var frs_num = server_result['result']['freeSpinNumber'];
    // if(in_free_spins_pos > 0) {
    //     frs_num = server_result['result']['freeSpinResults'][in_free_spins_pos - 1]['result']['freeSpinNumber']
    // }

    //console.warn(in_free_spins_total, frs_num);
    if(fsCurrent * 1 !== fsTotal * 1 /*in_free_spins_total*1 != frs_num || fsSkipping*/) {
        setTimeout(function() {
            addFs = 0;
            add_free_spins(fsResult, fsSkipping);
        }, 800);
        return;
    }

    setTimeout(function() {
        control_freespins(fsSkipping);
    }, timeout);
}

function add_text_to_symbol(name, text, selected)
{
    var dim = madnes_get_dimension(name);
    var color = selected ? 'yellow' : 'white';

    if(madnes_key_exist('text_' + name)) {
        madnes_remove_sprite('text_' + name);
    }

    madnes_add_bitmap_text('text_' + name, "fs_font_" + color, dim['width'] / 2, dim['height'] / 2 + 20, text, 70);

    madnes_add_child(name, 'text_' + name);
    madnes_set_img_center('text_' + name, 0.5, 0.5);
}

function getRandomFreeSpinNumber() {
    var min = 15 - 4;
    var max = 85;
    var r = Math.random() * (max - min + 1) + min;

    return Math.ceil(r/5)*5;
}

function getRandomFreeSpinNumberExcept(exceptNums) {
    do {
        var r = getRandomFreeSpinNumber();
    } while(exceptNums.indexOf(r) >= 0);

    return r;
}

let addFs = 0;
function add_free_spins(fsResult, fsSkipping)
{
    showTextBonusGames();

    // var frs_num = server_result['result']['freeSpinNumber'];
    // if(in_free_spins_pos > 0) {
    //     frs_num = server_result['result']['freeSpinResults'][in_free_spins_pos - 1]['result']['freeSpinNumber']
    // }

    // console.log(in_free_spins_total, in_free_spins_pos, server_result['result']['freeSpinResults'][in_free_spins_pos]['result']['freeSpinNumber']);
    if(fsCurrent + addFs <= fsTotal /*in_free_spins_total < frs_num*/)
    {
//		madnes_show_skip();
        madnes_audio_play("count");

        //in_free_spins_total++;

        if(in_free_spins)
        {
            //madnes_set_text("bckground_fs_bot_text", in_free_spins_pos + "/" + in_free_spins_total);
            madnes_set_text("text_bonus_games_num", freespins.getRoundNumber() + "/" + (fsCurrent + addFs));
        }
        else
        {
            //madnes_set_text("bckground_fs_bot_text", "0/0");
            madnes_set_text("text_bonus_games_num", "0/0");
        }

        addFs++;

        setTimeout(function() {
            add_free_spins(fsResult, fsSkipping);
        }, 150);
    }
    else
    {
//		madnes_hide_skip();
        fireQLocked = false;

        for(var h = 0; h < hidedSprites.length; h++) {
            madnes_set_visible(hidedSprites[h], true);
        }

        for(var f = 0; f < fireQs.length; f++) {
            madnes_remove_sprite(fireQs[f]['name']);
            madnes_remove_sprite(fireQs[f]['qName']);
        }

        // if(in_free_spins_total > 0) {
        // 	madnes_set_text("text_bonus_games_num", in_free_spins_pos + "/" + in_free_spins_total);
        // }

        showWinIconAndPlay();
        setTimeout(function() {
            control_freespins(fsSkipping);
        }, 1000);
    }
}

function showWinIconAndPlay() {
    madnes_set_visible('iconWin', true);
    madnes_anim_loop('iconWin', 'anim');
}

function hideWinIconAndStop() {
    madnes_audio_stop('fire2');
    madnes_set_visible('iconWin', false);
    madnes_anim_stop('iconWin');
}

function pulseWinIcon() {
    if(in_free_spins) {
        setTimeout(madnes_audio_play.bind(this, 'win_x3'), 0);
        madnes_anim_pulse('iconWin', 1.25, 1.25, 400, 0);
    }
}

function showTextBonusGames() {
    madnes_set_visible('text_bonus_games', true);
    madnes_set_visible('text_bonus_games_num', true);
}

function hideTextBonusGames() {
    madnes_set_visible('text_bonus_games', false);
    madnes_set_visible('text_bonus_games_num', false);
}

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

var actual_freespins_count = 0;

/**
 * @param {boolean} fsSkipping
 * @returns {undefined}
 */
async function control_freespins(fsSkipping)
{
    // var fs_win = spin_win;
    // var fs_count = madnes_get_fs_count();
    // var fs_order = in_free_spins_pos;

    let pos = freespins.getRoundIndex() + 1;

    let server_result_tmp = JSON.parse(JSON.stringify(server_result));
    var fsResults = server_result['result']['freeSpinResults'];

    spin_win = 0;


    if(typeof fsResults[pos] == "undefined" || fsResults[pos] == null)
    {
        madnes_end_freespins();

        set_in_free_spins(false);
        // in_free_spins_pos = 0;
        // in_free_spins_total = 0;

        actual_freespins_count = 0;

        //freespin_hide();
        hideWinIconAndStop();
        hideTextBonusGames();

        madnes_audio_stop('FS_BG');

        set_round_running(false);

        ctrl_end_round_freespins();

    } else {

        set_result_lock(1);
        set_rotated(0);
        set_round_running(false);

        let num = freespins.getFreeSpinNumber();

        await madnes_end_round();

        setTimeout(() => {

            set_server_result(server_result_tmp);

            madnes_set_text("text_bonus_games_num", (pos + 1) + "/" + num);

            set_result_lock(0);

            server_result.result.reelMatrix = fsResults[pos]['result']['reelMatrix'];
            //server_result.result.freeSpinNumber = fsResults[in_free_spins_pos]['result']['freeSpinNumber'];
            server_result.result.lineWins = fsResults[pos]['result']['lineWins'];
            server_result.result.gameSpecifics = fsResults[pos]['result']['gameSpecifics'];

        }, 700);
    }
}

async function result_control_part_proc_rem_color(win_set)
{
    await add_line_win(win_set);

//	win = win * 1 + win_set.win * 1;
//	spin_win = spin_win * 1 + win_set.win * 1;

    result_control_part_proc_trn(win_set);
}

function result_control_part_proc_trn(win_set)
{
    var endAnim = function(time) {
        setTimeout(function() {

            drawFrames.hideItems();

            if(typeof win_set.line != 'undefined') {
                madnes_set_visible(win_lines[win_set['line']]['line'], false);
            }

            result_control_pos++;
            result_control_part();
        }, time);
    };

    var frameColor = 'yellow';
    if(typeof win_set['line'] != 'undefined') {
        frameColor = win_lines[win_set['line']]['color'];
    }

    var drawFrames = new FrameDrawer(win_set);
    drawFrames.draw(frameColor);

    if(win_set.type != 'wild') {
        play_correct_sound(win_set);
    }

    var symbs = drawFrames.copy_sprites.concat(drawFrames.fade_in_symbols);

    var animSym1 = function() {
        if(win_set['type'] == 'wild') {
            if(drawFrames.fade_out_symbols.length) {
                madnes_audio_play('joker_change');
            }
            drawFrames.fadeOutWild(function() {
                drawFrames.scaleSymbols(symbs, endAnim.bind(this, 1200));
            });
        } else {
            drawFrames.scaleSymbols(symbs, endAnim.bind(this, 1200));
        }
    }

    if(in_free_spins) {
        pulseWinIcon();
        setTimeout(animSym1, 700);
    } else {
        animSym1();
    }
}

function set_symbol_center(symbName)
{
    madnes_set_img_center(symbName, 0.5, 0.5);
    madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) + madnes_get_dimension_wi(symbName) / 2);
    madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) + madnes_get_dimension_he(symbName) / 2);
}

function set_symbol_center_top_left(symbName)
{
    madnes_set_img_center(symbName, 0, 0);
    madnes_set_pos_x(symbName, madnes_get_pos_x(symbName) - madnes_get_dimension_wi(symbName) / 2);
    madnes_set_pos_y(symbName, madnes_get_pos_y(symbName) - madnes_get_dimension_he(symbName) / 2);
}

/**
 * @constructor
 * @param {Object} winset
 * @returns {FrameDrawer}
 */
function FrameDrawer(winset) {
    this.win_set = winset;
    this.items_to_hide = [];
    this.items_to_remove = [];
    this.fade_out_symbols = [];
    this.fade_in_symbols = [];
    this.copy_sprites = [];

    this.moveFrameX = 0;
    this.moveFrameY = 0;

    this.draw = function(color) {

        for(var pos in this.win_set['position']) {
            var itemX = this.win_set['position'][pos][0];
            var itemY = this.win_set['position'][pos][1];
            var itemSY = 2 - itemY;

            var spriteName = 'reels_bufer_' + itemX + '_S' + itemSY;
            var frameName = 'winframe_x' + itemX + '_y' + itemSY;

            madnes_set_texture(frameName, 'winframe_' + color);
            madnes_set_visible(frameName, true);
            madnes_set_pos_x(frameName, madnes_get_pos_x(spriteName) + this.moveFrameX);
            madnes_set_pos_y(frameName, madnes_get_pos_y(spriteName) + this.moveFrameY);


            var symbCopy = 'symcop_x' + itemX + '_y' + itemSY; //kopie symbolu na pozici
            /*madnes_set_texture(symbCopy, picture_convert[server_config.matrix.reelMatrix[itemX][itemSY]]);*/

            madnes_set_texture(symbCopy, madnes_get_texture(spriteName));
            madnes_set_visible(symbCopy, true);
            madnes_set_alpha(symbCopy, 1);

            madnes_set_pos_x(symbCopy, madnes_get_pos_x(spriteName));
            madnes_set_pos_y(symbCopy, madnes_get_pos_y(spriteName));

            set_symbol_center(symbCopy);

            if(is_in_scatter_position(itemX, itemY)) {
                (function(tSymbCopy) {

                    madnes_set_texture(tSymbCopy, "symbol_Fire_burn");
                    madnes_anim_add(tSymbCopy, "anim", icons["symbol_Fire_burn"]['anim']);
                    madnes_set_cstm_val(tSymbCopy, tSymbCopy);

                    madnes_set_pos_y(tSymbCopy, madnes_get_pos_y(tSymbCopy) - 4);

                    madnes_anim_add_oncomplete(tSymbCopy, function (sprite) {
                        madnes_set_texture(sprite['cstmVal'], "symbol_Fire");
                        //madnes_sprite_set_frame(sprite['cstmVal'], 0);

                        madnes_set_pos_y(sprite['cstmVal'], madnes_get_pos_y(sprite['cstmVal']) + 4);

                    });

                }(symbCopy))
            }

            this.copy_sprites.push(symbCopy);

            if(is_in_wild_position(itemX, itemY)) {

                var spriteNonWild = 'symcop_fadein_x' + itemX + '_y' + itemSY; //symbol, ktery wild prekryva;
                var nonWildTexture = picture_convert[this.win_set['symbol']];

                madnes_set_texture(spriteNonWild, nonWildTexture);

                madnes_set_pos_x(spriteNonWild, madnes_get_pos_x(spriteName));
                madnes_set_pos_y(spriteNonWild, madnes_get_pos_y(spriteName));
                madnes_set_alpha(spriteNonWild, 0);
                madnes_set_visible(spriteNonWild, true);
                set_symbol_center(spriteNonWild);

                //madnes_set_visible(spriteNonWild, false);
                this.fade_out_symbols.push(symbCopy);
                this.fade_in_symbols.push(spriteNonWild);
                this.items_to_hide.push(spriteNonWild);
            }

            this.items_to_hide.push(frameName);
            this.items_to_hide.push(symbCopy);
        }
    };

    this.fadeOutWild = function(callback) {

        for(var i = 0; i < this.fade_out_symbols.length; i++) {
            madnes_fade_out(this.fade_out_symbols[i], 300, 100);
        }

        for(var i = 0; i < this.fade_in_symbols.length; i++) {
            madnes_fade_in(this.fade_in_symbols[i], 300, 300);
        }

        setTimeout(function() {
            play_correct_sound(this.win_set);
            callback(2100);
        }.bind(this), 1000);
    };

    this.hideItems = function() {
        for(var i = 0; i < this.items_to_hide.length; i++) {
            madnes_set_visible(this.items_to_hide[i], false);
        }
    };

    this.endDraw = function() {
        this.hideItems();
    };

    this.animSymbols = function() {

        for(var i = 0; i < this.copy_sprites.length; i++) {
            var spriteName = this.copy_sprites[i];
            set_symbol_center_top_left(spriteName);

            if(typeof madnes_objects[spriteName]['animations'] != null) {
                madnes_anim_play(this.copy_sprites[i], 'anim');
            }
        }
    };

    this.scaleSymbols = function(sprites, cb) {

        var proms = [];

        for(var sym in sprites) {
            var scaleAnim = new AnimPulse(sprites[sym], 1.08, 1.08, 300, 0);
            var p = scaleAnim.run();
            proms.push(p);
        }

        Promise.all(proms).then(cb);
    };
}

function play_correct_sound(win_set) {
    madnes_audio_play('snd_win_' + get_audio_num(win_set) + get_yes(win_set));
}

function get_yes(win_set) {

    var position = win_set['position'];
    var symbol = win_set['symbol'];

    /*3x fire
    4x devil, melon, plum, cherry, A, K,
    5x lemon, orange, Q, J, 10, 9


    08: fire, devil
    06: 9
    05: lemin, oragne, , melon, plum, cherry
    04: A, K, Q, 10, J*/

    if(
        (symbol == 0 && position.length > 3) || //devil
        ((symbol == 1 || symbol == 2) && position.length > 3) || //melon, plum
        (symbol == 3 && position.length > 3) || //cherry
        ((symbol == 4 || symbol == 5) && position.length > 4) || //lemon, orange
        ((symbol == 6 || symbol == 7) && position.length > 3) || //A, K
        ((symbol == 8 || symbol == 9 || symbol == 10) && position.length > 4) || //Q, J, 10
        (symbol == 11 && position.length > 4) || //9
        (symbol == 12 && position.length > 2) //fire
    ) {
        return "_yes";
    }

    return "";
}

function get_audio_num(win_set) {

    if(win_set['symbol'] == 0 || win_set['symbol'] == 12) {
        return "bonus";
    }

    if(win_set['symbol'] == 11) {
        return "9";
    }

    if(win_set['symbol'] > 5) {
        return "low";
    }

    return "high";
}


function is_in_wild_position(x, y) {
    if(typeof server_result.result.gameSpecifics.wildPositions === 'undefined') {
        return false;
    }

    var wildPositions = server_result.result.gameSpecifics.wildPositions;
    for(var pos in wildPositions) {
        var wildX = wildPositions[pos][0];
        var wildY = wildPositions[pos][1];

        if(x === wildX && wildY === y) {
            return true;
        }
    }

    return false;
}

function is_in_scatter_position(x, y) {
    if(typeof server_result.result.gameSpecifics.scatterPositions === 'undefined') {
        return false;
    }

    var scatterPositions = server_result.result.gameSpecifics.scatterPositions;
    for(var pos in scatterPositions) {
        var scatX = scatterPositions[pos][0];
        var scatY = scatterPositions[pos][1];

        if(x === scatX && scatY === y) {
            return true;
        }
    }

    return false;
}